import React, { Component } from 'react';
import './TimerBar.module.scss';

class TimerBar extends Component {
    constructor(props) {
        super(props);
        
    }

    toTime(sec) {
        let pad = function(num, size) { return ('000' + num).slice(size * -1); },
            time = parseFloat(sec).toFixed(3),
            minutes = Math.floor(time / 60) % 60,
            seconds = Math.floor(time - minutes * 60);
        return pad(minutes, 2) + ':' + pad(seconds, 2);
    }

    render() {

        let width = Math.floor((this.props.timeLeft / this.props.totalTime) * 100);

        return (
            <div styleName="timer-background">
                <div styleName="bar-container">
                    <div styleName="progress-bar" style={{width: `${width}%`, backgroundColor: this.props.color}}/>
                </div>
                <p id='time'>{this.toTime(this.props.timeLeft)}</p>
            </div>
        );
    }
}

export default TimerBar;